import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import RepeatingName from './components/RepeatingName/RepeatingName';
import PageContainer from './components/PageContainer/PageContainer';
import MobileMenu from './components/MobileMenu/MobileMenu';
import RouteListener from "./components/RouteListener/RouteListener";
import AboutUs from './pages/AboutUs';
import MeetTheTeam from './pages/AboutUs/MeetTheTeam';
import JoinTheSociety from './pages/AboutUs/JoinTheSociety';
import History from './pages/AboutUs/History';
import Events from './pages/Events';
import UpcomingEvents from './pages/Events/UpcomingEvents';
import PreviousEvents from './pages/Events/PreviousEvents';
import Tools from './pages/Tools.js';
// import MembersOnly from './pages/MembersOnly';
// import ContactUs from './pages/ContactUs';
import Prayer from './pages/Prayer.js';
import RosaryCompanion from './pages/Prayer/RosaryCompanion.js';
import SevenSorrows from './pages/Prayer/SevenSorrows.js';
import DivineMercyChaplet from './pages/Prayer/DivineMercyChaplet.js';
import BulletinViewer from './pages/Tools/BulletinViewer.js'
import LitCal from './pages/Tools/LitCal.js'
import NotFound from './pages/NotFound';
import { waitForElement } from "./utils/GlobalFunctions.js";
import './App.css';
import HolyNameChaplet from "./pages/Prayer/HolyNameChaplet.js";

const App = () => {
	//===============================//
	//=  Mobile RepeatingName Size  =//
	//===============================//
	useEffect(() => {
		const loadElements = async () => {
			try {
				const resizingElements = await Promise.all([
					waitForElement('#repeating-name'),
					waitForElement('#opacity-gradient'),
					waitForElement('#slideable-content'),
				]);
				const bgNames = resizingElements[0];
				const bgGradient = resizingElements[1];
				const scrollContainer = resizingElements[2];
	
				// Stretch the repeating name components to expand beyond the viewport and into the overflow scroll section
				const updateHeights = () => {
					const newHeight = scrollContainer.scrollHeight;
					bgNames.style.height = `${newHeight}px`;
					bgGradient.style.height = `${newHeight}px`;
				}
				
				// Set up observer for continuous updates
				const resizeObserver = new ResizeObserver(updateHeights);
				resizeObserver.observe(scrollContainer);

				// Initial update
				updateHeights();
			} catch (error) {
				console.error("Error loading elements:", error);
			}
		}
		loadElements();
	}, []);

	return (
		<div id="slide-range">
			<MobileMenu />
			<div id="slideable-content">
				<RepeatingName />
				<Header />
				<PageContainer>
					<Router>
						<RouteListener />
						<Routes>
							<Route path="/" element={<AboutUs />} />
							<Route path="/officers" element={<MeetTheTeam />} />
							<Route path="/join" element={<JoinTheSociety />} />
							<Route path="/history" element={<History />} />
							<Route path="/events" element={<Events />} />
							<Route path="/upcoming_events" element={<UpcomingEvents />} />
							<Route path="/previous_events" element={<PreviousEvents />} />
							<Route path="/tools" element={<Tools />} />
							{/* <Route path="/members_only" element={<MembersOnly />} /> */}
							{/* <Route path="/contact" element={<ContactUs />} /> */}
							<Route path="/prayer" element={<Prayer />} />
							<Route path="/rosary" element={<RosaryCompanion />} />
							<Route path="/sorrows" element={<SevenSorrows />} />
							<Route path="/chaplet" element={<HolyNameChaplet />} />
							<Route path="/mercy" element={<DivineMercyChaplet />} />
							<Route path="/bulletins" element={<BulletinViewer />} />
							<Route path="/litcal" element={<LitCal />} />
							<Route path="*" element={<NotFound />} />
						</Routes>
					</Router>
				</PageContainer>
			</div>
		</div>
	);
};

export default App;
